import React, { VFC, RefObject, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { UserStorageActions } from 'reactApp/modules/user/userStorage';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import Tooltip from 'reactApp/ui/Tooltip/Tooltip';
import { tooltipPlacements } from 'reactApp/ui/Tooltip/Tooltip.constants';
import { CancelIcon } from 'reactApp/ui/VKUIIcons';

import styles from './FacesTooltip.css';

interface IProps {
    targetRef: RefObject<HTMLDivElement>;
    onApply: () => void;
}

const TOOLTIP_ID = 'faceTipViewerMobile';
const TOOLTIP_OFFSET = {
    y: 4,
    x: -16,
};

export const FacesTooltip: VFC<IProps> = ({ targetRef, onApply }) => {
    const dispatch = useDispatch();
    const showTip = !dispatch(UserStorageActions.get(TOOLTIP_ID));
    const [show, setShow] = useState(showTip);

    const handleClose = useCallback(() => {
        setShow(false);
        dispatch(UserStorageActions.set(TOOLTIP_ID, true));
    }, []);

    const handleApply = useCallback(() => {
        onApply();
        handleClose();
    }, [onApply, handleClose]);

    if (!show || !targetRef?.current) {
        return null;
    }

    return (
        <Tooltip
            theme="octavius"
            target={targetRef}
            placement={tooltipPlacements.BOTTOM_RIGHT}
            offset={TOOLTIP_OFFSET}
            smartPlacement={false}
            minWidth={false}
            pinned
            noPageOffset
        >
            <div className={styles.root}>
                <div className={styles.close} onClick={handleClose}>
                    <CancelIcon />
                </div>
                <div className={styles.title}>Люди на фото</div>
                <div className={styles.text}>
                    Облако умеет определять
                    <br />
                    людей на фото
                </div>
                <Button sizeMode={ButtonSizeMode.small} className={styles.button} theme="vk" primary onClick={handleApply}>
                    Показать
                </Button>
            </div>
        </Tooltip>
    );
};

FacesTooltip.displayName = 'FacesTooltip';
